import React from 'react';
import CropIconMapping from 'components/CropIconMapping';
import HighlightedText from 'components/HighlightedText';
import { TREE_PADDING } from '../../constants';
import TreeItemWrapper from '../TreeItemWrapper';

interface CropTreeItemProps {
  name: string;
  onClick: () => void;
  paddingClass?: string;
  searchTerm?: string;
}

const CropTreeItem: React.FC<CropTreeItemProps> = ({
  name,
  onClick,
  paddingClass = TREE_PADDING.CROP,
  searchTerm = ''
}) => {
  return (
    <TreeItemWrapper paddingClass={paddingClass} onClick={onClick}>
      <div className="flex items-center">
        <div className="shrink-0 mr-2">
          <CropIconMapping cropObject={{ name }} size={20} />
        </div>
        <HighlightedText
          text={name}
          searchTerm={searchTerm}
          className="font-medium text-sm truncate"
          style={{ display: 'block' }}
        />
      </div>
    </TreeItemWrapper>
  );
};

export default CropTreeItem;
